
// Import as svg
import { useSelector } from "react-redux";
import { ReactComponent as AuthSVG } from "../../assets/images/auth/main.svg";
import { Col } from "reactstrap";


const AuthVisual = () => {
    const globalTheme = useSelector(state => state.Theme);

    const { primaryColor, secondaryColor } = globalTheme;

    return (
        <Col lg="6" className="d-none d-lg-block auth-visual-panel">

            <div className="d-flex flex-column align-items-center">
                {/* Title styling with margin adjustments */}
                <h1
                    className="text-center mb-0 mt-5"
                    style={{
                        fontSize: "2.5rem",
                        fontWeight: "700",
                        // color: primaryColor, // Use your theme color
                        marginBottom: "1rem" // Adjust as needed
                    }}
                >
                    The Future of Pharmacy
                </h1>

                {/* SVG with adjusted margins */}
                <AuthSVG
                    style={{
                        width: "100%",
                        height: "auto", // Changed to auto to maintain aspect ratio
                        marginTop: "0.5rem", // Reduced margin to move it closer to the title
                        paddingLeft: ".5rem",
                        "--primary-fill": primaryColor, // Use CSS variables for SVG theming
                        "--secondary-fill": secondaryColor
                    }}
                />
            </div>
        </Col>
    )
}

export default AuthVisual;